(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["llo-watch-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pick(v, pre) { return v.getAttribute('data-' + pre + '-fb') || v.getAttribute('data-' + pre + '-src'); }
    function setup(root) {
      var hv = root.querySelector('.llo-wb__video');
      if (hv && !hv.dataset.wbReady) {
        hv.dataset.wbReady = '1';
        var mq = window.matchMedia('(max-width: 749px) and (orientation: portrait)');
        var apply = function () {
          var pre = (mq.matches && hv.hasAttribute('data-v-src')) || !hv.hasAttribute('data-h-src') ? 'v' : 'h';
          if (hv.dataset.wbPre === pre) return;
          hv.dataset.wbPre = pre;
          var poster = hv.getAttribute('data-' + pre + '-poster');
          if (poster) hv.setAttribute('poster', poster);
          var src = pick(hv, pre);
          if (src) { hv.src = src; }
          var fb = hv.getAttribute('data-' + pre + '-src');
          hv.onerror = function () { if (fb && hv.src !== fb) hv.src = fb; };
        };
        apply();
        if (mq.addEventListener) mq.addEventListener('change', function () { if (hv.paused) apply(); });
        hv.addEventListener('play', function () { hv.classList.add('is-playing'); });
        root.querySelectorAll('[data-wb-play]').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); hv.scrollIntoView({ behavior: 'smooth', block: 'center' }); hv.play(); });
        });
      }
      root.querySelectorAll('.llo-wb__svideo').forEach(function (v) {
        if (v.dataset.wbReady) return; v.dataset.wbReady = '1';
        var src = pick(v, 's'), fb = v.getAttribute('data-s-src');
        if (src) v.src = src;
        v.onerror = function () { if (fb && v.src !== fb) v.src = fb; };
        v.addEventListener('play', function () {
          v.classList.add('is-playing');
          root.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        });
        var btn = v.parentNode.querySelector('[data-wb-short]');
        if (btn) btn.addEventListener('click', function () { v.play(); });
      });
      if (hv) hv.addEventListener('play', function () { root.querySelectorAll('.llo-wb__svideo').forEach(function (o) { if (!o.paused) o.pause(); }); });
    }
    function all() { document.querySelectorAll('.llo-wb').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
